export function auditParams(state) {
  return state.auditParams;
}
export function audits(state) {
  return state.audits;
}
export function auditsMeta(state) {
  return state.auditsMeta;
}
export function entry(state) {
  return state.entry;
}
export function comments(state) {
  return state.comments;
}
export function commentsMeta(state) {
  return state.commentsMeta;
}
export function commentsChildren(state) {
  return state.commentsChildren;
}
export function commentsChildrenMeta(state) {
  return state.commentsChildrenMeta;
}
export function response(state) {
  return state.response;
}
export function unseens(state) {
  return state.unseens;
}